
import { defineComponent, useContext } from '@nuxtjs/composition-api'

export default defineComponent({
  setup () {
    const { redirect, query, app: { localePath } } = useContext()
    redirect(301, localePath({
      path: '/car/search',
      query: query.value,
    }))
  },
})
